import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import CreditEngines from './BankRules.vue';

export const routes = [
  {
    path: 'motores-credito',
    name: 'talkvia_credit_engines',
    meta: {
      permissions: ['administrator'],
      superAdminOnly: true,
    },
    featureFlag: FEATURE_FLAGS.TALKVIA_CORBAN_CREDIT_ENGINE,
    component: CreditEngines,
  },
];
